import { RackEvent } from 'libs/ui';

export const Warning = (props) => {
  return <RackEvent {...props} icon="warning.png" type="medium" />;
};

export default Warning;
